import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';

import * as styles from './StarsRow.css';

interface IStarsRow {
  title: string;
}

export const StarsRow = ({ children, title }: React.PropsWithChildren<IStarsRow>) => {
  return (
    <div className={styles['row']}>
      <div className={styles['title']}>
        <UIHeading4>{title}</UIHeading4>
      </div>
      {children}
    </div>
  );
};
